var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Corrosion.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Corrosion.text,
      "bgImage": "/images/sub/product/corrosion-bg.jpg",
      "image": "/images/sub/product/corrosion-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 부식 측정, 제어 및 예방 분야에서는 재료와 구조물의 다양한 부식 원인과 영향을 관리하기 위해 다양한 솔루션이 사용됩니다. 이러한 활동은 부식 원인과 재료 또는 구조물의 유형에 따라 다르게 적용될 수 있습니다. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 부식 제어 및 예방 분야에서는 음극 및 양극 보호, 재료 선택, 화학 처리, 내부 및 외부 코팅의 적용과 같은 기술적 옵션이 있습니다. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 부식 측정은 해당 환경의 부식성과 부식률을 모니터링하기 위해 다양한 기술적 기법이 사용됩니다. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 부식 측정은 부식 제어 및 예방 기술의 효과를 정량적으로 평가하고, 부식 방지 및 제어 방법을 개선하기 위한 정보를 제공함으로써, 최적화된 부식 제어 및 솔루션을 제시합니다. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }